import each from './each';
import isArray from './is-array';
import isFunction from './is-function';
var hasOwnProperty = Object.prototype.hasOwnProperty;

function groupBy(data, condition) {
  if (!condition || !isArray(data)) {
    return {};
  }

  var result = {}; // 兼容方法和 字符串的写法

  var predicate = isFunction(condition) ? condition : function (item) {
    return item[condition];
  };
  var key;
  each(data, function (item) {
    key = predicate(item);

    if (hasOwnProperty.call(result, key)) {
      result[key].push(item);
    } else {
      result[key] = [item];
    }
  });
  return result;
}

export default groupBy;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/group-by.js
// module id = 24
// module chunks = 0